<template>
  <alert show>
    <template v-slot:title>
      {{ $t("views.single.candidate.delete_pin") }}
    </template>
    <template v-slot:content>
      {{ $t("views.single.candidate.delete_pin_desc") }}
    </template>
    <template v-slot:footer>
      <div class="flex w-full">
        <navigate-small-button
          :theme="'border-interaction-dark'"
          @click="$emit('dismiss')"
          class="flex-1 uppercase"
          style="margin-right: 3%"
        >
          {{ $t("views.single.candidate.cancel_delete_pin") }}
        </navigate-small-button>
        <navigate-small-button
          :theme="'contrast-light'"
          @click="$emit('delete-pin')"
          class="flex-1"
        >
          {{ $t("views.single.candidate.confirm_delete_pin") }}
        </navigate-small-button>
      </div>
    </template>
  </alert>
</template>

<script>
import Alert from "@/components/layouts/Alert";
import NavigateSmallButton from "@/components/buttons/NavigateSmallButton";

export default {
  name: "DeletePinModal",
  components: {
    NavigateSmallButton,
    Alert
  }
};
</script>
